import { useState, useContext } from "react";
import "../../Style/actionstyle.scss";
import { MdDelete, MdModeEdit } from "react-icons/md";
import { AuthContext } from "../../Context/AuthContext";
import { IconButton, Stack, Box, Tooltip } from "@mui/material";
import LessonForm from "./LessonForm";
import useDeleteLesson from "./Hooks/useDeleteLesson";
import DialogDelete from "../../Utils/DialogDelete";

export default function ContentAction({ editData, setRefetch }) {
  // Change Language
  const { t } = useContext(AuthContext);

  //Modal update
  const [openEdit, setOpenEdit] = useState(false);
  const handleOpenEdit = () => setOpenEdit(true);
  const handleCloseEdit = () => setOpenEdit(false);

  //Modal delete
  const [openDel, setOpenDel] = useState(false);
  const handleOpenDel = () => setOpenDel(true);
  const handleCloseDel = () => setOpenDel(false);

  const { handleDelete, loading } = useDeleteLesson({
    handleClose: handleCloseDel,
    editData: editData,
    setRefetch,
  });

  return (
    <div>
      <Stack direction="row" justifyContent="right">
        <Tooltip title={t("update")} placement="top">
          <IconButton onClick={handleOpenEdit}>
            <Box className="update-container">
              <MdModeEdit className="update-icon" />
            </Box>
          </IconButton>
        </Tooltip>

        <Tooltip title={t("delete")} placement="top">
          <IconButton onClick={handleOpenDel}>
            <Box className="delete-container">
              <MdDelete className="delete-icon" />
            </Box>
          </IconButton>
        </Tooltip>
      </Stack>

      {openEdit && (
        <LessonForm
          dialogTitle={"Update"}
          open={openEdit}
          editData={editData}
          setRefetch={setRefetch}
          handleClose={handleCloseEdit}
          // contentId={editData?.contentId?._id}
          classId={editData?.classId?._id}
        />
      )}

      {openDel && (
        <DialogDelete
          open={openDel}
          handleClose={handleCloseDel}
          loading={loading}
          deleteTitle={t("modal_title_delete_lesson")}
          handleDelete={handleDelete}
          editData={editData}
        />
      )}
    </div>
  );
}
